'use client';

import { useDispatch } from 'react-redux';

import { Icon } from '@/shared/ui/icon';
import { IconButton } from '@/shared/ui/icon-button';

import { siteMenuActions } from '../model/site-menu-slice';

export function MenuButton() {
  const dispatch = useDispatch();
  return (
    <IconButton
      label="Открыть меню"
      aria-haspopup="dialog"
      onClick={() => dispatch(siteMenuActions.opened())}
    >
      <Icon name="burger" />
    </IconButton>
  );
}
